import * as Vue from 'vue';

import App from './App.vue'
import router from './router'
import store from './core/store/store'
import '@fortawesome/fontawesome-free/css/all.css'
import '@mdi/font/css/materialdesignicons.css'

import VueGtag from 'vue-gtag-next';
import { config, pageView } from './plugins/analytics';
import i18n from './i18n/i18n'
import toast from './plugins/toast'

const app = Vue.createApp(App)

app.use(VueGtag, config);

// Ensure store is used before router
app.use(store)
app.use(router)
app.use(i18n)

// Registra this.$toast, usado em 31 pontos do jogo e que ate agora nao existia.
app.use(toast)

router.afterEach((to) => {
    if (process.env.VUE_APP_NODE_ENV === 'production') {
        setTimeout(() => {
        pageView(to.name || to.path, to.fullPath);
        }, 100);
    }
});

app.mount('#app')
